import { render, staticRenderFns } from "./selectOption.vue?vue&type=template&id=12f85ae0&scoped=true"
import script from "./selectOption.vue?vue&type=script&lang=js"
export * from "./selectOption.vue?vue&type=script&lang=js"
import style0 from "./selectOption.vue?vue&type=style&index=0&id=12f85ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f85ae0",
  null
  
)

export default component.exports